import PropTypes from "prop-types";

const ProjectQuestionGroupShape = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  title: PropTypes.string
});

export default ProjectQuestionGroupShape;
